<div class="scroll-container">
  <div class="container" *ngFor="let plano of planos">
    <div (click)="onSelectedPlano(plano)" class="card"
        [ngClass]="plano.id == planoSelecionado?.id ? 'selectPlano' : ''">
      <div class="card-header">
        <img class="planoImage" src="../../../../assets/img/plano/plano_icon.png" alt="Emblema do plano">
        <div class="plano-info">
          <p class="planoNome">{{ plano.nome }}</p>
          <p class="planoDescricao">{{ getValorPlano(plano) }}</p>
          <p class="planoDescricao textUpload">{{ plano.limiteMb }}Mb de upload</p>
        </div>
      </div>
      <div class="card-body">
        <p class="planoNome">Benefícios</p>
        <ul class="beneficios-lista">
          <li *ngFor="let beneficio of getBeneficios(plano)">
            <span class="planoDescricao">{{ beneficio }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
